import Vue from 'vue';
import Router from 'vue-router';
import Login from '../views/Login.vue';
import SignUp from '../views/SignUp.vue';
import about from '../views/about.vue';
import Map from '../views/Map.vue';
import forsyn from '../views/forsyn.vue';
import forsynlist from '../views/forsynlist.vue';
import forsynadd from '../views/forsynadd.vue';
import forsynPDF from '../views/forsynPDF.vue';
import calendar from '../views/calendar.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/forsyn-list',
      name: 'forsynlist',
      component: forsynlist,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/forsynadd',
      name: 'Försyn',
      component: forsynadd,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/forsyn/:id',
      name: 'forsyn',
      component: forsyn,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/forsynPDF/:id',
      name: 'forsynPDF',
      component: forsynPDF,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/calendar',
      name: 'Kalender',
      component: calendar,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        requiresAuth: true
      },
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js